import { Link } from 'react-router-dom';

import { ROUTE_PATHS } from 'src/shared/config/routes';
import { Product } from 'src/shared/types/product';

import { Typography } from 'src/shared/components/ui';

import ProductsTable from './ProductsTable';

interface ArchivedTabContentProps {
  isLoading?: boolean;
  /** Archived products only. */
  products?: Product[];
  isSuccess?: boolean;
}

/**
 * The "Archived" tab. Once loading has settled with nothing archived there is
 * nothing to sort or scan through, so the empty table is skipped entirely in
 * favour of a centred placeholder that points back to the "Sourcing" tab.
 */
const ArchivedTabContent: React.FC<ArchivedTabContentProps> = ({
  isLoading,
  products,
  isSuccess
}) => {
  const hasArchivedProducts = (products?.length ?? 0) > 0;

  if (isSuccess && !hasArchivedProducts) {
    return (
      <div className="flex flex-col justify-center items-center gap-2 h-full">
        <Typography variant="body-1" className="text-secondary-text">
          No archived products
        </Typography>
        <Link
          to={`${ROUTE_PATHS.PRODUCTS}?tab=sourcing`}
          className="text-primary underline text-sm font-medium"
        >
          Go to sourcing
        </Link>
      </div>
    );
  }

  return (
    <ProductsTable
      isLoading={isLoading}
      products={products}
      isSuccess={isSuccess}
      header="Archived"
    />
  );
};

export default ArchivedTabContent;
